<template>
<b-container class="register-organization-container">
        <div class="login-form-wrapper">
<branding-heading></branding-heading>
<b-row v-show="loading">
	<b-col class="pb-3">
		<b-spinner label="Checking Your Approval Code..."></b-spinner> Checking server... please wait...
	</b-col>
</b-row>
<b-row v-show="status == 'success'">
	<b-col >
	<h2>Organization request is now Approved.</h2>
	<p><router-link to="/" class="btn btn-primary">Back to Lane Closures</router-link></p>

	</b-col>
</b-row>
<b-row v-show="status == 'error'">
	<b-col >
	<h2>There was a problem confirming your approval code.</h2>
	<p class="error" v-html="getError"></p>
	<p>Please make sure that the link you clicked on in your email contains the full URL.</p>
	</b-col>
</b-row>

<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
	<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
	<ul>
		<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
	</ul>
	<template slot="footer">
		<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
	</template>
</b-modal>
</div>
</b-container>
</template>


<script>
import BootstrapField from '../../../utility/BootstrapField';
import ErrorHandler from '../../../utility/ErrorHandler';
import Format from '../../../utility/Format';
import Vue from 'vue'
import BrandingHeading from '../../../components/BrandingHeading';

export default {
  name: 'ApproveOrganizationRegistration',
  docTitle: "Approve Organization Request - Lane Closures",

  components: {
  	BrandingHeading
  },
  props:['jwt'],
  data() {
	return {
		form: null,
		lineIndexError:null,
		error:null,
		isButtonDisabled: false,
		saveState:null,
		modalRequiredFieldList: [],
		showRequiredFieldModal: false,
		show: true,
		status:null,
		loading:false,
		submitted: false,
		resendToken:null,
		onSubmitPromiseDeferred: {
			resolve:null,
			reject:null
		},
		usernamePrefix:new BootstrapField({
					value: null}),
	}
	},
	mounted() {
		this.sendConfirmToken();
		this.$nextTick(() => {
		})
   },
	computed: {
		getError() {
			if (this.error) {
				return this.error.error.message;
			}
			return null;
		},
	},
	watch: {
	},
  methods: {

	// required fields notifying modal
	modalRequiredFieldClose(){
		this.showRequiredFieldModal = false;
	},
	getFlatTree(option) {
		if (option.namePath) {
			return Format.pipesToFlatTree(option.namePath);
		} else {
			return option.name;
		}
	},
	showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

		sendConfirmToken() {
			if (this.jwt != null) {
				this.loading = true;
				Vue.prototype.$http({
					method: 'get',
					url: `${this.$store.state.apiUrl}/approve-organization-registration/?jwt=${this.jwt}&r=${Math.round(Math.random() * Math.pow(10, 6))}`
				}).then(response => {
					// Handle Success
					this.loading  = false;
					this.status = "success";
					// console.log(response);
				}).catch(error => {
					this.loading = false;
					this.saveState = 'fail';
					this.status = "error";
					this.error = error.response.data;
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.form.SetErrors(error.response.data);
						// this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
					// this.onSubmitPromiseDeferred.reject();
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},

	},
	beforeRouteLeave(to, from, next) {
			next(true);
	},

}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>